/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Login_Reset_InstructionsInputs */



/**
* | output |
* | --- |
* | "Enter your email and we'll send you a link to reset your password." |
*
* @param {Login_Reset_InstructionsInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const login_reset_instructions = /** @type {((inputs?: Login_Reset_InstructionsInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Login_Reset_InstructionsInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Entrez votre email et nous vous enverrons un lien pour réinitialiser votre mot de passe.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Ingrese su correo electrónico y le enviaremos un enlace para restablecer su contraseña.")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Digite seu e-mail e enviaremos um link para redefinir sua senha.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Inserisci la tua email e ti invieremo un link per reimpostare la password.")
	return /** @type {LocalizedString} */ ("Enter your email and we'll send you a link to reset your password.")
});